import React, { createContext, useContext, useState, useEffect } from "react";

const DICT = {
  id: {
    "app.name": "SatuCRM", "app.tagline": "Simple CRM for Bigger Opportunities",
    "auth.login": "Masuk", "auth.register": "Daftar", "auth.logout": "Keluar",
    "auth.email": "Email", "auth.password": "Password", "auth.fullName": "Nama Lengkap",
    "auth.company": "Nama Perusahaan", "auth.phone": "Nomor Telepon",
    "auth.forgot": "Lupa password?", "auth.noAccount": "Belum punya akun?",
    "auth.haveAccount": "Sudah punya akun?", "auth.google": "Lanjutkan dengan Google",
    "auth.or": "atau", "auth.welcome": "Selamat datang kembali",
    "auth.welcomeSub": "Masuk untuk melanjutkan mengelola pipeline Anda",
    "auth.registerTitle": "Buat workspace CRM Anda",
    "auth.registerSub": "Gratis untuk memulai, tanpa kartu kredit",
    "nav.dashboard": "Dashboard", "nav.contacts": "Kontak", "nav.leads": "Leads",
    "nav.deals": "Deals / Pipeline", "nav.activities": "Aktivitas",
    "nav.followup": "Follow-up", "nav.customers": "Pelanggan",
    "nav.reports": "Laporan", "nav.settings": "Pengaturan",
    "kpi.totalLeads": "Total Leads", "kpi.newLeads": "Leads Baru",
    "kpi.activeDeals": "Deal Aktif", "kpi.wonDeals": "Deal Menang",
    "kpi.lostDeals": "Deal Kalah", "kpi.pipelineValue": "Nilai Pipeline",
    "kpi.followupToday": "Follow-up Hari Ini", "kpi.overdue": "Terlambat",
    "kpi.revenue": "Pendapatan",
    "action.add": "Tambah", "action.edit": "Ubah", "action.delete": "Hapus",
    "action.save": "Simpan", "action.cancel": "Batal", "action.search": "Cari...",
    "action.filter": "Filter", "action.convert": "Konversi", "action.complete": "Selesai",
    "action.newLead": "Lead Baru", "action.newContact": "Kontak Baru",
    "action.newDeal": "Deal Baru", "action.newFollowup": "Follow-up Baru",
    "action.logActivity": "Catat Aktivitas",
    "greeting": "Selamat datang kembali",
    "followup.today": "Hari Ini", "followup.upcoming": "Akan Datang",
    "followup.overdue": "Terlambat", "followup.completed": "Selesai", "followup.all": "Semua",
    "contact.all": "Semua Kontak", "contact.companies": "Perusahaan",
    "contact.customers": "Pelanggan", "contact.prospects": "Prospek",
  },
  en: {
    "app.name": "SatuCRM", "app.tagline": "Simple CRM for Bigger Opportunities",
    "auth.login": "Sign in", "auth.register": "Sign up", "auth.logout": "Log out",
    "auth.email": "Email", "auth.password": "Password", "auth.fullName": "Full name",
    "auth.company": "Company name", "auth.phone": "Phone",
    "auth.forgot": "Forgot password?", "auth.noAccount": "Don't have an account?",
    "auth.haveAccount": "Already have an account?", "auth.google": "Continue with Google",
    "auth.or": "or", "auth.welcome": "Welcome back",
    "auth.welcomeSub": "Sign in to continue managing your pipeline",
    "auth.registerTitle": "Create your CRM workspace",
    "auth.registerSub": "Free to start, no credit card required",
    "nav.dashboard": "Dashboard", "nav.contacts": "Contacts", "nav.leads": "Leads",
    "nav.deals": "Deals / Pipeline", "nav.activities": "Activities",
    "nav.followup": "Follow-up", "nav.customers": "Customers",
    "nav.reports": "Reports", "nav.settings": "Settings",
    "kpi.totalLeads": "Total Leads", "kpi.newLeads": "New Leads",
    "kpi.activeDeals": "Active Deals", "kpi.wonDeals": "Won Deals",
    "kpi.lostDeals": "Lost Deals", "kpi.pipelineValue": "Pipeline Value",
    "kpi.followupToday": "Follow-up Today", "kpi.overdue": "Overdue",
    "kpi.revenue": "Revenue",
    "action.add": "Add", "action.edit": "Edit", "action.delete": "Delete",
    "action.save": "Save", "action.cancel": "Cancel", "action.search": "Search...",
    "action.filter": "Filter", "action.convert": "Convert", "action.complete": "Complete",
    "action.newLead": "New Lead", "action.newContact": "New Contact",
    "action.newDeal": "New Deal", "action.newFollowup": "New Follow-up",
    "action.logActivity": "Log Activity",
    "greeting": "Welcome back",
    "followup.today": "Today", "followup.upcoming": "Upcoming",
    "followup.overdue": "Overdue", "followup.completed": "Completed", "followup.all": "All",
    "contact.all": "All Contacts", "contact.companies": "Companies",
    "contact.customers": "Customers", "contact.prospects": "Prospects",
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("satucrm.lang") || "id");
  useEffect(() => { localStorage.setItem("satucrm.lang", lang); }, [lang]);
  const t = (key) => DICT[lang]?.[key] || DICT.id[key] || key;
  return (
    <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>
  );
}
export const useI18n = () => useContext(I18nCtx);
